"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_NEED_MFA_HTTP_CODE = exports.USER_NEED_PAYMENT_HTTP_CODE = exports.TOKEN_SESSION_MISSMATCH_HTTP_CODE = exports.NEED_MFA_ERROR_CODES = exports.NEED_PAYMENT_ERROR_CODES = exports.NEED_RELOGIN_ERROR_CODES = exports.ERROR_TYPE = exports.CAPTCHA_PATH = exports.EXCHANGE_ACCESS_TOKEN_PATH = exports.SYNC_TOKEN_PAIRS_PATH = exports.DESTROY_SESSION_PATH = exports.SUBMIT_LOGIN_FORM_PATH = exports.PUBLIC_KEY_PATH = exports.AUTH_SERVER = void 0;
exports.AUTH_SERVER = 'https://passport.zhihuiya.com';
exports.PUBLIC_KEY_PATH = '/public/request_public_key';
exports.SUBMIT_LOGIN_FORM_PATH = '/loginsubmit';
exports.DESTROY_SESSION_PATH = '/logout';
exports.SYNC_TOKEN_PAIRS_PATH = '/checksession';
exports.EXCHANGE_ACCESS_TOKEN_PATH = '/token/refresh';
exports.CAPTCHA_PATH = '/public/captcha';
var ERROR_TYPE;
(function (ERROR_TYPE) {
    ERROR_TYPE["AUTH"] = "access_error";
    ERROR_TYPE["PAYMENT"] = "payment_error";
    ERROR_TYPE["MFA"] = "mfa_error";
})(ERROR_TYPE = exports.ERROR_TYPE || (exports.ERROR_TYPE = {}));
var NEED_RELOGIN_ERROR_CODES;
(function (NEED_RELOGIN_ERROR_CODES) {
    /**
     * 401 被踢出
     */
    NEED_RELOGIN_ERROR_CODES["Kickout"] = "30409";
    NEED_RELOGIN_ERROR_CODES["Kickout2"] = "30410";
    NEED_RELOGIN_ERROR_CODES["ssoKickout"] = "30411";
    NEED_RELOGIN_ERROR_CODES["ssoKickout2"] = "30412";
    /**
     * 401 会话过期
     */
    NEED_RELOGIN_ERROR_CODES["Outdated"] = "30407";
    /**
     * 409 会话不存在
     */
    NEED_RELOGIN_ERROR_CODES["NoExist"] = "30401";
    /**
     * 409 会话与当前账号不匹配 (不一定需要跳登陆)
     */
    // NoMatch = '30402',
    NEED_RELOGIN_ERROR_CODES["Overrun"] = "30404";
    /**
     * 400 需要更新密码
     */
    NEED_RELOGIN_ERROR_CODES["NeedUpdatePassword"] = "30152";
    /**
     * 租户用户不存在
     */
    NEED_RELOGIN_ERROR_CODES["TenantUserNoExist"] = "30801";
})(NEED_RELOGIN_ERROR_CODES = exports.NEED_RELOGIN_ERROR_CODES || (exports.NEED_RELOGIN_ERROR_CODES = {}));
var NEED_PAYMENT_ERROR_CODES;
(function (NEED_PAYMENT_ERROR_CODES) {
    NEED_PAYMENT_ERROR_CODES["ConcurrencyExceedException"] = "30413";
    NEED_PAYMENT_ERROR_CODES["EnterpriseLimitationException"] = "30414";
})(NEED_PAYMENT_ERROR_CODES = exports.NEED_PAYMENT_ERROR_CODES || (exports.NEED_PAYMENT_ERROR_CODES = {}));
var NEED_MFA_ERROR_CODES;
(function (NEED_MFA_ERROR_CODES) {
    NEED_MFA_ERROR_CODES["MfaVerificationRequired"] = "32001";
    NEED_MFA_ERROR_CODES["MfaBindingRequired"] = "32004";
})(NEED_MFA_ERROR_CODES = exports.NEED_MFA_ERROR_CODES || (exports.NEED_MFA_ERROR_CODES = {}));
exports.TOKEN_SESSION_MISSMATCH_HTTP_CODE = 409;
exports.USER_NEED_PAYMENT_HTTP_CODE = 402;
exports.USER_NEED_MFA_HTTP_CODE = 403;
//# sourceMappingURL=constants.js.map